"use client";
import { jsxs as _, jsx as o } from "react/jsx-runtime";
import { Icon as s } from "../icon/icon.js";
import { useState as g, useId as h } from "react";
import { Flex as N } from "../../primitives/flex/flex.js";
import w from "clsx";
import { b as E } from "../../virginmediao2-momentum-icons-icons-fas-CfzopcU1.js";
import '../../assets/accordion.css';const v = "_accordion_n44cp_1", j = "_accordion__trigger_n44cp_29", y = "_accordion__subtitles_n44cp_38", I = "_accordion__subtitle_n44cp_38", z = "_accordion__title_n44cp_51", F = "_accordion__suffix_n44cp_59", k = "_accordion__indicator_n44cp_80", A = "_accordion__prefix_n44cp_81", C = "_accordion__content_n44cp_140", D = "_accordion__panel_n44cp_146", S = "_accordionExpand_n44cp_1", c = {
  accordion: v,
  "accordion--expanded": "_accordion--expanded_n44cp_15",
  accordion__trigger: j,
  accordion__subtitles: y,
  accordion__subtitle: I,
  "accordion__title-wrapper": "_accordion__title-wrapper_n44cp_51",
  accordion__title: z,
  accordion__suffix: F,
  accordion__indicator: k,
  accordion__prefix: A,
  "accordion__subtitle--success": "_accordion__subtitle--success_n44cp_96",
  "accordion__subtitle--error": "_accordion__subtitle--error_n44cp_101",
  "accordion__subtitle--warning": "_accordion__subtitle--warning_n44cp_106",
  "accordion__subtitle--info": "_accordion__subtitle--info_n44cp_111",
  "accordion__subtitle-icon": "_accordion__subtitle-icon_n44cp_116",
  "accordion__subtitle-text": "_accordion__subtitle-text_n44cp_120",
  accordion__content: C,
  accordion__panel: D,
  accordionExpand: S
}, L = ({
  children: r,
  title: l,
  expanded: a,
  icon: t,
  renderWhenCollapsed: d = !0,
  titleProps: p,
  bodyProps: u,
  bodyContainerProps: b,
  info: e,
  className: m = "",
  ...x
}) => {
  const [n, f] = g(a), i = h();
  return /* @__PURE__ */ _(
    "div",
    {
      id: i,
      className: w(
        {
          [c.accordion]: !0,
          [c["accordion--expanded"]]: n
        },
        m
      ),
      ...x,
      children: [
        /* @__PURE__ */ o(
          "button",
          {
            "data-testid": "accordion__trigger",
            className: c.accordion__trigger,
            "aria-expanded": n,
            "aria-controls": i,
            onClick: () => f(!n),
            ...p,
            children: /* @__PURE__ */ _("span", { className: c["accordion__title-wrapper"], children: [
              t && /* @__PURE__ */ o("span", { className: c.accordion__icon, children: /* @__PURE__ */ o(s, { icon: t, size: "md" }) }),
              /* @__PURE__ */ _(N, { justify: "between", align: "center", grow: 1, children: [
                /* @__PURE__ */ o("span", { className: c.accordion__title, children: l }),
                e ? /* @__PURE__ */ o("span", { className: c.accordion__info, children: e }) : null
              ] }),
              /* @__PURE__ */ o("span", { className: c.accordion__indicator, children: /* @__PURE__ */ o(s, { icon: E, size: "md" }) })
            ] })
          }
        ),
        /* @__PURE__ */ o(
          "div",
          {
            "data-testid": "accordion__panel",
            role: "region",
            className: c.accordion__panel,
            "aria-labelledby": i,
            ...b,
            children: /* @__PURE__ */ _(
              "div",
              {
                "data-testid": "accordion__content",
                className: c.accordion__content,
                ...u,
                children: [
                  !d && a && r,
                  d && r
                ]
              }
            )
          }
        )
      ]
    }
  );
};
export {
  L as Accordion
};
